/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/location';
import '../../../common/time';
import '../component/component';
import '../glyph/glyph_icon';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "checking_idv": {
                "nested": {
                  "AccountHolder": {
                    "fields": {
                      "firstName": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "middleName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "lastName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "address": {
                        "type": "squareup.common.location.GlobalAddress",
                        "id": 4,
                        "rule": "optional"
                      },
                      "dateOfBirth": {
                        "type": "squareup.common.time.YearMonthDay",
                        "id": 5,
                        "rule": "optional"
                      },
                      "nationalIdentifier": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "ErrorScreen": {
                    "fields": {
                      "title": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "subtitle": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "skipButton": {
                        "type": "squareup.bbfrontend.common.component.ButtonDescription",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "PendingApprovalScreen": {
                    "fields": {
                      "title": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "explanationSection": {
                        "type": "squareup.bbfrontend.common.checking_idv.PendingApprovalScreen.ExplanationSection",
                        "id": 2,
                        "rule": "optional"
                      },
                      "skipButton": {
                        "type": "squareup.bbfrontend.common.component.ButtonDescription",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ExplanationSection": {
                        "fields": {
                          "sectionTitle": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "items": {
                            "type": "squareup.bbfrontend.common.checking_idv.PendingApprovalScreen.ExplanationSection.Item",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "Item": {
                            "fields": {
                              "icon": {
                                "type": "squareup.bbfrontend.common.glyph.GlyphIcon",
                                "id": 1,
                                "rule": "optional"
                              },
                              "text": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "RetryScreen": {
                    "fields": {
                      "eyebrow": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "title": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "checkListItems": {
                        "type": "squareup.bbfrontend.common.checking_idv.RetryScreen.CheckListItem",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "skipButton": {
                        "type": "squareup.bbfrontend.common.component.ButtonDescription",
                        "id": 5,
                        "rule": "optional"
                      },
                      "retryButton": {
                        "type": "squareup.bbfrontend.common.component.ButtonDescription",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CheckListItem": {
                        "fields": {
                          "title": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "EditAccountHolderScreen": {
                    "fields": {
                      "accountHolder": {
                        "type": "squareup.bbfrontend.common.checking_idv.AccountHolder",
                        "id": 1,
                        "rule": "optional"
                      },
                      "banner": {
                        "type": "squareup.bbfrontend.common.component.BannerDescription",
                        "id": 2,
                        "rule": "optional"
                      },
                      "firstNameInput": {
                        "type": "squareup.bbfrontend.common.component.TextInputDescription",
                        "id": 3,
                        "rule": "optional"
                      },
                      "middleNameInput": {
                        "type": "squareup.bbfrontend.common.component.TextInputDescription",
                        "id": 4,
                        "rule": "optional"
                      },
                      "lastNameInput": {
                        "type": "squareup.bbfrontend.common.component.TextInputDescription",
                        "id": 5,
                        "rule": "optional"
                      },
                      "addressInput": {
                        "type": "squareup.bbfrontend.common.component.AddressInputDescription",
                        "id": 6,
                        "rule": "optional"
                      },
                      "dobInput": {
                        "type": "squareup.bbfrontend.common.component.DateInputDescription",
                        "id": 7,
                        "rule": "optional"
                      },
                      "nationalIdentifierInput": {
                        "type": "squareup.bbfrontend.common.component.TextInputDescription",
                        "id": 8,
                        "rule": "optional"
                      },
                      "verifyButton": {
                        "type": "squareup.bbfrontend.common.component.ButtonDescription",
                        "id": 9,
                        "rule": "optional"
                      },
                      "editContext": {
                        "type": "bytes",
                        "id": 10,
                        "rule": "optional"
                      }
                    }
                  },
                  "CheckingIdvScreen": {
                    "fields": {
                      "errorScreen": {
                        "type": "squareup.bbfrontend.common.checking_idv.ErrorScreen",
                        "id": 1
                      },
                      "pendingApprovalScreen": {
                        "type": "squareup.bbfrontend.common.checking_idv.PendingApprovalScreen",
                        "id": 2
                      },
                      "retryScreen": {
                        "type": "squareup.bbfrontend.common.checking_idv.RetryScreen",
                        "id": 3
                      },
                      "editAccountHolderScreen": {
                        "type": "squareup.bbfrontend.common.checking_idv.EditAccountHolderScreen",
                        "id": 4
                      }
                    },
                    "nested": {
                      "screen": {
                        "oneof": ["errorScreen", "pendingApprovalScreen", "retryScreen", "editAccountHolderScreen"]
                      }
                    }
                  },
                  "IdvResult": {
                    "fields": {
                      "notDecided": {
                        "type": "squareup.bbfrontend.common.checking_idv.IdvResult.NotDecided",
                        "id": 1
                      },
                      "passed": {
                        "type": "squareup.bbfrontend.common.checking_idv.IdvResult.Passed",
                        "id": 2
                      },
                      "notPassed": {
                        "type": "squareup.bbfrontend.common.checking_idv.IdvResult.NotPassed",
                        "id": 3
                      }
                    },
                    "nested": {
                      "NotDecided": {
                        "fields": {
                          "pollContext": {
                            "type": "bytes",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "Passed": {
                        "fields": {}
                      },
                      "NotPassed": {
                        "fields": {
                          "checkingIdvScreens": {
                            "type": "squareup.bbfrontend.common.checking_idv.CheckingIdvScreen",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "result": {
                        "oneof": ["notDecided", "passed", "notPassed"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.AccountHolder && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.ErrorScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.PendingApprovalScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.PendingApprovalScreen?.nested?.ExplanationSection && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.PendingApprovalScreen?.nested?.ExplanationSection?.nested?.Item && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.RetryScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.RetryScreen?.nested?.CheckListItem && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.EditAccountHolderScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.CheckingIdvScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.IdvResult && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.IdvResult?.nested?.NotDecided && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.IdvResult?.nested?.Passed && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.checking_idv?.nested?.IdvResult?.nested?.NotPassed) {
  $root.addJSON(jsonData);
}

/**
 * Square account holder information required for IDV.
 *
 * SOURCE AccountHolder @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 17:1
 */
export const AccountHolder = $root.lookupType('squareup.bbfrontend.common.checking_idv.AccountHolder');
fixType(AccountHolder, {
  firstName: {
    notEmpty: true
  },
  lastName: {
    notEmpty: true
  },
  address: {
    required: true
  },
  dateOfBirth: {
    required: true
  }
});
Builder.createAndAttachToType(AccountHolder);
/**
 * Error screen to display IDV states that are not passed.
 *
 * SOURCE ErrorScreen @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 29:1
 */
export const ErrorScreen = $root.lookupType('squareup.bbfrontend.common.checking_idv.ErrorScreen');
fixType(ErrorScreen, {
  title: {
    notEmpty: true
  },
  skipButton: {
    required: true
  }
});
Builder.createAndAttachToType(ErrorScreen);
/**
 * Screen to display when IDV is in pending approval state (e.g. in manual review state).
 *
 * SOURCE PendingApprovalScreen @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 39:1
 */
export const PendingApprovalScreen = $root.lookupType('squareup.bbfrontend.common.checking_idv.PendingApprovalScreen');
fixType(PendingApprovalScreen, {
  title: {
    notEmpty: true
  },
  explanationSection: {
    required: true
  },
  skipButton: {
    required: true
  }
});
Builder.createAndAttachToType(PendingApprovalScreen);
/**
 * The section to display a list of explanation items.
 *
 * SOURCE ExplanationSection @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 41:3
 */
PendingApprovalScreen.ExplanationSection = $root.lookupType('squareup.bbfrontend.common.checking_idv.PendingApprovalScreen.ExplanationSection');
fixType(PendingApprovalScreen.ExplanationSection, {
  sectionTitle: {
    notEmpty: true
  },
  items: {
    required: true
  }
});
Builder.createAndAttachToType(PendingApprovalScreen.ExplanationSection);
/**
 * SOURCE Item @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 42:5
 */
PendingApprovalScreen.ExplanationSection.Item = $root.lookupType('squareup.bbfrontend.common.checking_idv.PendingApprovalScreen.ExplanationSection.Item');
fixType(PendingApprovalScreen.ExplanationSection.Item, {
  icon: {
    required: true
  },
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PendingApprovalScreen.ExplanationSection.Item);
/**
 * The screen to display when IDV is not passed, and the user can retry the IDV process.
 *
 * SOURCE RetryScreen @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 61:1
 */
export const RetryScreen = $root.lookupType('squareup.bbfrontend.common.checking_idv.RetryScreen');
fixType(RetryScreen, {
  eyebrow: {
    notEmpty: true
  },
  title: {
    notEmpty: true
  },
  description: {
    notEmpty: true
  },
  checkListItems: {
    required: true
  },
  skipButton: {
    required: true
  },
  retryButton: {
    required: true
  }
});
Builder.createAndAttachToType(RetryScreen);
/**
 * SOURCE CheckListItem @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 62:3
 */
RetryScreen.CheckListItem = $root.lookupType('squareup.bbfrontend.common.checking_idv.RetryScreen.CheckListItem');
fixType(RetryScreen.CheckListItem, {
  title: {
    notEmpty: true
  },
  description: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetryScreen.CheckListItem);
/**
 * The screen to edit the account holder information.
 *
 * SOURCE EditAccountHolderScreen @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 85:1
 */
export const EditAccountHolderScreen = $root.lookupType('squareup.bbfrontend.common.checking_idv.EditAccountHolderScreen');
fixType(EditAccountHolderScreen, {
  accountHolder: {
    required: true
  },
  firstNameInput: {
    required: true
  },
  middleNameInput: {
    required: true
  },
  lastNameInput: {
    required: true
  },
  addressInput: {
    required: true
  },
  dobInput: {
    required: true
  },
  nationalIdentifierInput: {
    required: true
  },
  verifyButton: {
    required: true
  },
  editContext: {
    required: true
  }
});
Builder.createAndAttachToType(EditAccountHolderScreen);
/**
 * SOURCE CheckingIdvScreen @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 108:1
 */
export const CheckingIdvScreen = $root.lookupType('squareup.bbfrontend.common.checking_idv.CheckingIdvScreen');
fixType(CheckingIdvScreen);
Builder.createAndAttachToType(CheckingIdvScreen);
/**
 * The result of Checking IDV.
 *
 * SOURCE IdvResult @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 118:1
 */
export const IdvResult = $root.lookupType('squareup.bbfrontend.common.checking_idv.IdvResult');
fixType(IdvResult);
Builder.createAndAttachToType(IdvResult);
/**
 * The IDV result is not decided yet.
 *
 * SOURCE NotDecided @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 120:3
 */
IdvResult.NotDecided = $root.lookupType('squareup.bbfrontend.common.checking_idv.IdvResult.NotDecided');
fixType(IdvResult.NotDecided, {
  pollContext: {
    required: true
  }
});
Builder.createAndAttachToType(IdvResult.NotDecided);
/**
 * The seller has passed the IDV.
 *
 * SOURCE Passed @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 126:3
 */
IdvResult.Passed = $root.lookupType('squareup.bbfrontend.common.checking_idv.IdvResult.Passed');
fixType(IdvResult.Passed);
Builder.createAndAttachToType(IdvResult.Passed);
/**
 * The seller has not passed the IDV.
 * Note: The seller may be able to retry the IDV process.
 *
 * SOURCE NotPassed @ squareup/bbfrontend/common/checking_idv/checking_idv.proto at 130:3
 */
IdvResult.NotPassed = $root.lookupType('squareup.bbfrontend.common.checking_idv.IdvResult.NotPassed');
fixType(IdvResult.NotPassed, {
  checkingIdvScreens: {
    required: true
  }
});
Builder.createAndAttachToType(IdvResult.NotPassed);